import Vue from 'vue';
import store from './store';
import router from './router/';
import './plugins/element.js';
import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
